 <template>
<div>
<p>build number: 5.5</p>
<p>hotfix for adress</p>
</div>
</template>
<script>
export default {
  data(){
    return{
      isAuth : false
    }
  },
 methods: {
  },
}
</script>



// WEBPACK FOOTER //
// Version.vue?145897ff